import apiClient from "./apiClient";

export const createLicense = async (licenseData) => {
  try {
    const response = await apiClient.post('/license', licenseData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchLicenses = async (params = {}) => {
  try {
    const { search = "", page = 1, limit = 10 } = params || {};
    const response = await apiClient.get(`/license/?page=${page}&limit=${limit}&search=${search}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteLicense = async (licenseId) => {
  try {
    const response = await apiClient.delete('/license', {
      data: { licenseId }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateLicense = async (licenseData) => {
  try {
    const response = await apiClient.put('/license', licenseData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const changeLicenseStatus = async (statusData) => {
  try {
    const response = await apiClient.patch('/license/status', statusData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchLicenseUsage = async (params = {}) => {
  try {
    const { licenseId, itsalesId, search = '', page = 1, limit = 10 } = params;
    let url = `/license/track-usage?licenseId=${licenseId}&itsalesId=${itsalesId}&search=${search}&page=${page}&limit=${limit}`;
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};